import React  from "react";
import { Container, Row, Col, Card, CardBody } from "shards-react";
import { MDBDataTable } from 'mdbreact';
import {firebases } from '../config';
import DashboardOverview from './DashboardOverview';
import PageTitle from "../components/common/PageTitle";
import RowImages from "../components/common/RowImages";
import Actions from "../components/common/Actions";

import { Link } from "react-router-dom";

import { MDBBtn, MDBBtnGroup, MDBIcon} from "mdbreact";


const firebaseNotes = firebases.database().ref().child('notes');
const firebaseVideos = firebases.database().ref().child('videos');
const firebaseCourses = firebases.database().ref().child('courses');
const firebaseCategory = firebases.database().ref().child('category');
const firebaseSubcategory = firebases.database().ref().child('subCategory');
const firebaseChapters = firebases.database().ref().child('chapters');
const firebaseExercises = firebases.database().ref().child('exercises');
const firebaseQuestions = firebases.database().ref().child('questions');


let context = null;

class Dashboard extends React.Component {

  constructor(props){
    super();
    this.state ={list:[],sourceList:[],
  username: "",
  avatar: "",
  isUploading: false,
  progress: 0,

  notes:0,
  chapters:0,
  courses:0,
  videos:0,
  category:0,
  subCategory:0,
  exercises:0,
  questions:0,

  avatarURL: "",};

  context = this;
  
   
}

componentDidMount(){

  this.setCountForDb(firebaseNotes,'notes');
  this.setCountForDb(firebaseVideos,'videos');
  this.setCountForDb(firebaseCourses,'courses');
  this.setCountForDb(firebaseCategory,'category');
  this.setCountForDb(firebaseSubcategory,'subCategory');
  this.setCountForDb(firebaseChapters,'chapters');
  this.setCountForDb(firebaseExercises,'exercises');
  this.setCountForDb(firebaseQuestions,'questions');

}


setCountForDb(firebaseDb,name){

  firebaseDb.on('value', snap => {
    
    let dbList = [];
    let sourceList = [];
    console.log(snap);
    snap.forEach(shot => {
      sourceList.push({ ...shot.val(), key: shot.key });
    });


    context.setState({[name]: sourceList.length}); 
   


  });
}





  render() {

   const item = this.state;
return(  <DashboardOverview  item={item}/>
);
}

}

export default Dashboard;
